import * as React from 'react';

import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';

import { UserMenuOptions } from '../../../../../florence/constants/UserMenuOptions';
import { ReactComponent as LockIcon } from '../../../../assets/icons/lock_icon.svg';
import { ReactComponent as LogoutIcon } from '../../../../assets/icons/logout_icon.svg';
import { ReactComponent as ScanIcon } from '../../../../assets/icons/scan_icon_blue.svg';
import { ReactComponent as ShieldCheck } from '../../../../assets/icons/shield-check.svg';
import { ReactComponent as StarIcon } from '../../../../assets/icons/star_icon_blue.svg';
import { useAppSelector } from '../../../../hooks/reduxHooks';
import StyledPopover from '../../../StyledPopover';

interface Props {
  handleClose: () => void;
  anchorEl: HTMLElement | null;
  open: boolean;
  id?: string;
  handleSelectedItem: (item: UserMenuOptions) => void;
}

const HeaderMenu: React.FC<Props> = ({
  handleClose,
  anchorEl,
  open,
  id,
  handleSelectedItem,
}) => {
  const { user } = useAppSelector((state) => state.model);

  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
    >
      <MenuList>
        <MenuItem onClick={() => handleSelectedItem(UserMenuOptions.Account)}>
          <ListItemIcon>
            <LockIcon />
          </ListItemIcon>
          <Typography>{UserMenuOptions.Account}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => handleSelectedItem(UserMenuOptions.Subscription)}
        >
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <Typography>{UserMenuOptions.Subscription}</Typography>
        </MenuItem>
        {!user?.organizationId && (
          <MenuItem
            onClick={() => handleSelectedItem(UserMenuOptions.ScanPackage)}
          >
            <ListItemIcon>
              <ScanIcon />
            </ListItemIcon>
            <Typography>{UserMenuOptions.ScanPackage}</Typography>
          </MenuItem>
        )}
        <MenuItem onClick={() => handleSelectedItem(UserMenuOptions.Logout)}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <Typography>{UserMenuOptions.Logout}</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleSelectedItem(UserMenuOptions.TFactor)}>
          <ListItemIcon>
            <ShieldCheck />
          </ListItemIcon>
          <Typography>{UserMenuOptions.TFactor}</Typography>
        </MenuItem>
      </MenuList>
    </StyledPopover>
  );
};

export default HeaderMenu;
